'use client';

import React from 'react';
import styled from '@emotion/styled';
import { CloseIcon, HamburgerIcon } from "@argo/ui-elements";
import { breakpoints, size } from "@argo/principles";
import { HAMBURGER_MENU_ID, NAV_HEIGHT } from '../utils/constants';
const Toggle = styled.label`
  cursor: pointer;
  display: inline-block;
  position: relative;
  width: ${({
  iconSize
}) => iconSize}px;
  height: ${({
  iconSize
}) => iconSize}px;
  padding: ${({
  iconSize
}) => (NAV_HEIGHT - iconSize) / 2}px ${size.xs}px;
  padding-right: ${size.sm}px;

  > svg {
    position: absolute;

    &:first-of-type {
      display: inline-block;
    }

    &:last-of-type {
      display: none;
    }
  }

  @media (min-width: ${breakpoints.lg}px) {
    padding-right: ${size.md / 2}px;
    padding-left: ${size.md / 2}px;
    margin-right: ${size.md / 2}px;
  }
`;
const ToggleBox = styled.input`
  display: none;

  &:checked {
    + label svg{
      &:first-of-type {
        display: none;
      }

      &:last-of-type {
        display: inline-block;
      }
    }
  }
`;
const HamburgerToggler = ({
  onMenuClick,
  menuOpenState,
  iconSize
}) => {
  const {
    isMenuOpen,
    menuId
  } = menuOpenState;
  const isNavOpen = isMenuOpen && menuId === HAMBURGER_MENU_ID;
  return React.createElement(React.Fragment, null, React.createElement(ToggleBox, {
    type: 'checkbox',
    id: HAMBURGER_MENU_ID
  }), React.createElement(Toggle, {
    htmlFor: HAMBURGER_MENU_ID,
    iconSize: iconSize,
    onClick: onMenuClick,
    className: 'menu-item',
    "data-menu-state": isNavOpen ? "open" : "closed"
  }, React.createElement(HamburgerIcon, {
    color: "white",
    size: iconSize
  }), React.createElement(CloseIcon, {
    color: "white",
    size: iconSize
  })));
};
export default HamburgerToggler;